import { App } from "App";
import { ArcElement, Chart, Tooltip } from "chart.js";
import { TranslationsProvider } from "providers";
import { EnumLabelsProvider } from "providers";
import { AppBannerProvider } from "providers/AppBanners/AppBannerProvider";
import { AuthenticationProvider } from "providers/Authentication/AuthenticationProvider";
import { StrictMode } from "react";
import { CookiesProvider } from "react-cookie";
import * as ReactDOM from "react-dom/client";

// register chart.js components
Chart.register(ArcElement, Tooltip);

const element = document.getElementById("root") as Element;
const root = ReactDOM.createRoot(element);

root.render(
  <CookiesProvider defaultSetOptions={{ path: "/" }}>
    <TranslationsProvider>
      <EnumLabelsProvider>
        <AuthenticationProvider>
          <AppBannerProvider>
            <StrictMode>
              <App />
            </StrictMode>
          </AppBannerProvider>
        </AuthenticationProvider>
      </EnumLabelsProvider>
    </TranslationsProvider>
  </CookiesProvider>
);
